<span class="patient-chip">{{ label || ('shared.patient-chip.patient' | exp:'':'Paciente') }}</span>
